export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const toStages = stages =>
  stages.map(stage => ({
    value: stage.id,
    label: stage.name,
    color: stage.color,
    categoryColor: stage.category.color
  }))
